/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/RadioButton/theme';

export const RadioButtonTheme = theme;
